export default __webpack_public_path__ + "static/media/globeWhite.0d891e4e.svg";